// read by `this.$root.$option[key]`
const constant = Object.create(null)

const lsKey = Object.create(null)
lsKey.browserTip = 'mt_bike_associate_browser_tip'

const DECODE_TYPE = {
  ID_CARD: 1, // 身份证
  BANK_ACCOUNT: 2, // 银行卡
  PHONE: 3, // 手机号
  EMAIL: 4, // 邮箱
  ADDRESS: 5, // 地址
}

export { lsKey, DECODE_TYPE }
export default constant
